<div class="table-section">
    <app-my-forms-list></app-my-forms-list>
</div>